//Library Imports
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store, { RootState } from "store";

//Local Imports
import { getQueryCampaignId } from "modules/EmailBrowser/utils";
import { IVersion } from "modules/Campaigns/interfaces";
import { getSentEmails, resetAll } from "../actions";

import { EMAIL_LIST } from "constants/types";
import EditionsList from "./EditionsList";
import { EMAIL_TYPE_MAP } from "constants/index";

interface ISentEditionsWrapper {
  isSearch: boolean;
  previousSentSearch: string;
  date: any;
  emailType: any;
  user: any;
}

const DEFAULT_PAGE_LIMIT = 20; //* later on api hits

const SentEditionsWrapper: React.FC<ISentEditionsWrapper> = (props: ISentEditionsWrapper) => {
  //Others
  const { isSearch, previousSentSearch, date, emailType, user } = props;
  const assetType: any = useSelector((state: RootState) => state.assetDetails.assetType);
  const campaignId = getQueryCampaignId();
  const [firstRender, setFirstRender] = useState(false);

  //Sent Editions
  const sentEditionsLoading: boolean = useSelector((state: RootState) => state.emails?.sentEmails?.loading);
  const sentEditions: IVersion[] = useSelector((state: RootState) => state.emails?.sentEmails?.data);
  const hasMoreSent = useSelector((state: RootState) => state.emails?.hasMoreSent);
  const searchSentLoading: boolean = useSelector((state: RootState) => state.assetDetails.searchSentLoading);

  const getPagination = (isFirstLoad = false) => {
    let offset = 0;
    if (!isFirstLoad) {
      offset = sentEditions.length;
    }
    let limit = DEFAULT_PAGE_LIMIT; //update to 4

    return {
      offset,
      limit,
      asset_id: campaignId,
      version_status: "Sent",
      test_emails: false,
      // ...(date && !isSearch ? date : {}),
    };
  };

  const loadMore = () => {
    if (!sentEditionsLoading) {
      getSentEmails(campaignId, {
        ...getPagination(),
        ...(isSearch ? { search_term: previousSentSearch } : {}),
        ...(user.value === "default" ? {} : { user_id: user.value }),
        ...(EMAIL_TYPE_MAP[emailType.value] === "" ? {} : { email_type: EMAIL_TYPE_MAP[emailType.value] }),
      });
    }
  };

  useEffect(() => {
    const updatedRest = store.getState().emails.reset;
    if (sentEditions.length === 0 || updatedRest)
      getSentEmails(
        campaignId,
        {
          ...getPagination(true),
          ...(user.value === "default" ? {} : { user_id: user.value }),
          ...(EMAIL_TYPE_MAP[emailType.value] === "" ? {} : { email_type: EMAIL_TYPE_MAP[emailType.value] }),
        },
        false,
        updatedRest
      );
    else store.dispatch({ type: EMAIL_LIST.SENT_LOAD_OFF });
    setFirstRender(true);
  }, []);

  useEffect(() => {
    if (firstRender) {
      resetAll();
      getSentEmails(
        campaignId,
        {
          ...getPagination(true),
          ...(user.value === "default" ? {} : { user_id: user.value }),
          ...(EMAIL_TYPE_MAP[emailType.value] === "" ? {} : { email_type: EMAIL_TYPE_MAP[emailType.value] }),
          ...(previousSentSearch?.length > 0 ? { search_term: previousSentSearch } : {}),
        },
        true
      );
    }
  }, [user, emailType]);

  return (
    <>
      <EditionsList
        editionsLength={sentEditions.length}
        loadMore={loadMore}
        hasMore={hasMoreSent}
        editionsLoading={sentEditionsLoading}
        editions={sentEditions}
        assetType={assetType}
        campaignId={campaignId}
        isSearch={isSearch}
        noEmailText={`No sent emails found.`}
        noSearchEmailText={`No sent emails found against your search`}
        searchSentLoading={searchSentLoading}
      />
    </>
  );
};

export default SentEditionsWrapper;
